import eventEmiters from './eventEmiters/index';
import headerEvents from '@front-box/Navigation/UiHeader/analytics/headerEvents'
import $analytics from './customAnalytics';
import events from './events';

export const customAnalyticsInit = () => {

  const allEvents = { ...events, ...headerEvents }

  /* eslint-disable-next-line */
  if (!isGbHost) {
    Object.keys(allEvents).forEach(event => $analytics.createEvent(event, allEvents[event]))

    window.$analytics = $analytics;

    eventEmiters();
  }
};
